'use client'
import { TextField as MuiTextField } from '@mui/material'
import { FieldValue } from '@/types'
import { memo } from 'react'

type TextFieldProps = {
  id: string
  value: FieldValue
  placeholder?: string
  isHidden: boolean
  isLabel?: boolean
  onChangeHandler: (val: FieldValue, id: string, isLabel?: boolean) => void
}

const TextField = ({ id, value, placeholder, isHidden, isLabel, onChangeHandler }: TextFieldProps) => {
  // Ensure value is always a string
  const inputValue = value === undefined || value === null ? '' : String(value)

  return (
    <MuiTextField
      placeholder={placeholder}
      value={inputValue}
      variant="outlined"
      hiddenLabel
      size="small"
      fullWidth
      disabled={isHidden}
      onChange={(e) => onChangeHandler(e.target.value, id, isLabel)}
    />
  )
}

export default memo(TextField)
